<template>
  <div class="wos-load">
    <div class="row" v-if="false">
      <div class="form-group col-sm-12 col-lg-12 text-left">
        <label class="control-label">{{ $t("scale.weighing_on_scale.reception_type") }}</label>
        <DxRadioGroup
          v-model="localData.reception_type_id"
          :data-source="receptionTypesList"
          display-expr="name"
          value-expr="id"
          layout="horizontal"
          @value-changed="onReceptionTypeChanged"
        />
      </div>
    </div>
    <div
      class="row"
      v-if="[WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.SALES, WEIGHING_TYPES.FIELD_REPORT].includes(localData.weighing_type_id)"
    >
      <div class="form-group col-sm-12 col-lg-4">
        <label class="control-label">{{ $t("scale.weighing_on_scale.contract_number") }}</label>
        <div
          class="sm-select-input-dialog-btn"
          @click="contractClick"
          :class="{ 'field-error': this.$v.localData.selectedContracts.$error }"
        >
          <div class="sm-select-input-dialog-info">
            <div class="sm-select-input-dialog-value">{{ getContractNames }}</div>
          </div>
          <div class="sm-select-input-dialog-actions">
            <span
              v-if="localData.selectedContracts && localData.selectedContracts.length > 0"
              class="sm-select-input-dialog-clear"
              @click.stop="clearSelectedContracts"
              :title="$t('common.delete')"
            >
              <i class="fa fa-times"></i>
            </span>
            <span class="sm-select-input-dialog-icon">
              <i class="fa-regular fa-edit"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="form-group col-sm-12 col-lg-4" v-if="isFieldReportWithSaleAndIntermediary">
        <label class="control-label">{{ $t("scale.weighing_on_scale.contract_number_for_sale") }}</label>
        <div
          class="sm-select-input-dialog-btn"
          @click="secondaryContractClick"
          :class="{ 'field-error': this.$v.localData.selectedSaleContracts.$error }"
        >
          <div class="sm-select-input-dialog-info">
            <div class="sm-select-input-dialog-value">{{ getSecondaryContractNames }}</div>
          </div>
          <div class="sm-select-input-dialog-actions">
            <span
              v-if="localData.selectedSaleContracts && localData.selectedSaleContracts.length > 0"
              class="sm-select-input-dialog-clear"
              @click.stop="clearSelectedSecondaryContracts"
              :title="$t('common.delete')"
            >
              <i class="fa fa-times"></i>
            </span>
            <span class="sm-select-input-dialog-icon">
              <i class="fa-regular fa-edit"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="localData.weighing_type_id != WEIGHING_TYPES.CONTRACTED_MEASUREMENTS">
      <div class="form-group col-sm-12 col-lg-4 text-left">
        <label class="control-label">{{ $t("common.product") }}</label>
        <div class="sm-select-input-dialog-btn" @click="productClick">
          <div class="sm-select-input-dialog-info">
            <div class="sm-select-input-dialog-value">{{ getProductNames }}</div>
          </div>
          <div class="sm-select-input-dialog-icon">
            <i class="fa-regular fa-edit"></i>
          </div>
        </div>
      </div>
      <div
        class="form-group col-sm-12 col-lg-4"
        v-if="[WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.SALES].includes(localData.weighing_type_id)"
      >
        <label class="control-label">{{ $t("common.partner") }}</label>
        <div class="sm-select-input-dialog-btn" @click="partnerClick" :class="{ 'field-error': this.$v.localData.partner_uuid.$error }">
          <div class="sm-select-input-dialog-info">
            <div class="sm-select-input-dialog-value">{{ getPartnerNames }}</div>
          </div>
          <div class="sm-select-input-dialog-icon">
            <i class="fa-regular fa-edit"></i>
          </div>
        </div>
      </div>
      <div class="form-group col-sm-12 col-lg-4 text-left" v-if="isIntermediaryWarehouseRequired">
        <label class="control-label">{{ $t("scale.weighing_on_scale.intermediary_warehouse") }}</label>
        <DxSelectBox
          v-model="localData.intermediary_warehouse_uuid"
          :data-source="intermediaryWarehouses"
          :on-value-changed="onIntermediaryWarehouseChanged"
          :search-enabled="true"
          :display-expr="warehouseDisplayExpr"
          value-expr="uuid"
          placeholder=""
          :class="{
            'field-error': this.$v.localData.intermediary_warehouse_uuid?.$error,
          }"
        />
      </div>
    </div>
    <div class="row" v-if="localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT">
      <div class="form-group col-sm-12 col-lg-4">
        <label class="control-label">{{ $t("common.parcels") }}</label>
        <div class="sm-select-input-dialog-btn" @click="parcelClick" :class="{ 'field-error': this.$v.localData.selectedParcels.$error }">
          <div class="sm-select-input-dialog-info">
            <div class="sm-select-input-dialog-value">{{ getParcelNames }}</div>
            <div class="reception_input_second_value">
              {{ getSelectedParcelCountForInput }}
            </div>
          </div>
          <div class="sm-select-input-dialog-actions">
            <span
              v-if="localData.selectedParcels && localData.selectedParcels.length > 0"
              class="sm-select-input-dialog-clear"
              @click.stop="clearSelectedParcels"
              :title="$t('common.delete')"
            >
              <i class="fa fa-times"></i>
            </span>
            <span class="sm-select-input-dialog-icon">
              <i class="fa-regular fa-edit"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS">
      <div class="row">
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("scale.weighing_on_scale.buyer_seller_name") }}</label>
          <DxAutocomplete
            v-model="localData.buyer_seller_name"
            :data-source="getBuyerSellerNameHistory()"
            :min-search-length="0"
            :show-clear-button="true"
            :class="{
              'field-error': this.$v.localData.buyer_seller_name.$error,
            }"
            @value-changed="onBuyerSellerNameSelected"
          />
        </div>
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("scale.weighing_on_scale.partner_name") }}</label>
          <DxAutocomplete
            v-model="localData.partner_name"
            :data-source="getPartnerNameHistory()"
            :min-search-length="0"
            :show-clear-button="true"
            :class="{
              'field-error': this.$v.localData.partner_name.$error,
            }"
            @value-changed="onPartnerNameSelected"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("scale.weighing_on_scale.buyer_seller_address") }}</label>
          <DxAutocomplete
            v-model="localData.buyer_seller_address"
            :data-source="getBuyerSellerAddressHistory()"
            :min-search-length="0"
            :show-clear-button="true"
          />
        </div>
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("scale.weighing_on_scale.partner_address") }}</label>
          <DxAutocomplete
            v-model="localData.partner_address"
            :data-source="getPartnerAddressHistory()"
            :min-search-length="0"
            :show-clear-button="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("common.product") }}</label>
          <DxAutocomplete
            v-model="localData.product_name"
            :data-source="getProductNameHistory()"
            :min-search-length="0"
            :show-clear-button="true"
            :class="{
              'field-error': this.$v.localData.product_name.$error,
            }"
            @value-changed="onProductNameSelected"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t("scale.weighing_on_scale.product_code") }}</label>
          <DxAutocomplete
            v-model="localData.product_code"
            :data-source="getProductCodeHistory()"
            :min-search-length="0"
            :show-clear-button="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="form-group col-sm-12 col-lg-4 text-left"
        v-if="
          localData.weighing_type_id == WEIGHING_TYPES.RECEPTION ||
          localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT ||
          localData.weighing_type_id == WEIGHING_TYPES.TRANSFER
        "
        :class="{
          'field-error': this.$v.localData.recipient_warehouse_uuid.$error,
        }"
      >
        <label class="control-label">{{ $t("scale.weighing_on_scale.recipient_warehouse") }}</label>
        <DxTagBox
          v-if="isSimpleFieldReportWithoutContract"
          v-model="localData.recipient_warehouse_uuids"
          :data-source="recipientWarehouses"
          :search-enabled="true"
          :display-expr="warehouseDisplayExpr"
          value-expr="uuid"
          :show-selection-controls="true"
          :hide-selected-items="false"
          :max-displayed-tags="2"
          :show-multi-tag-only="false"
          @value-changed="onRecipientWarehousesChanged"
        />
        <DxSelectBox
          v-else
          v-model="localData.recipient_warehouse_uuid"
          :data-source="recipientWarehouses"
          :on-value-changed="onWarehouseChangedRecipient"
          :search-enabled="true"
          :display-expr="warehouseDisplayExpr"
          value-expr="uuid"
          placeholder=""
        />
      </div>
      <div
        class="form-group col-sm-12 col-lg-4 text-left"
        v-if="localData.weighing_type_id == WEIGHING_TYPES.SALES || localData.weighing_type_id == WEIGHING_TYPES.TRANSFER"
        :class="{
          'field-error': this.$v.localData.issuer_warehouse_uuid.$error,
        }"
      >
        <label class="control-label">{{ $t("scale.weighing_on_scale.issuer_warehouse") }}</label>
        <DxSelectBox
          v-model="localData.issuer_warehouse_uuid"
          :data-source="issuerWarehouses"
          :on-value-changed="onWarehouseChangedIssuer"
          :search-enabled="true"
          :display-expr="warehouseDisplayExpr"
          value-expr="uuid"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-4 form-group">
        <label class="control-label">{{ $t("scale.weighing_on_scale.unloading_place") }}</label>
        <DxAutocomplete
          v-model="localData.unloading_place"
          :data-source="unloadingPlaceHistory"
          :min-search-length="0"
          :show-clear-button="true"
        />
      </div>
      <div class="col-sm-12 col-lg-4 form-group" v-if="showSalePlacesInputs">
        <label class="control-label">{{ $t("scale.weighing_on_scale.unloading_place_sale") }}</label>
        <DxAutocomplete
          v-model="localData.sale_unloading_place"
          :data-source="unloadingPlaceHistory"
          :min-search-length="0"
          :show-clear-button="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-4 form-group">
        <label class="control-label">{{ $t("scale.weighing_on_scale.uploading_place") }}</label>
        <DxAutocomplete
          v-model="localData.uploading_place"
          :data-source="uploadPlaceHistory"
          :min-search-length="0"
          :show-clear-button="true"
        />
      </div>
      <div class="col-sm-12 col-lg-4 form-group" v-if="showSalePlacesInputs">
        <label class="control-label">{{ $t("scale.weighing_on_scale.uploading_place_sale") }}</label>
        <DxAutocomplete
          v-model="localData.sale_uploading_place"
          :data-source="uploadPlaceHistory"
          :min-search-length="0"
          :show-clear-button="true"
        />
      </div>
    </div>
    <div class="row" v-if="localData.weighing_type_id == WEIGHING_TYPES.TRANSFER">
      <div class="form-group col-sm-12 col-lg-4 text-left" >
        <label class="control-label">{{ $t("scale.weighing_on_scale.generate_delivery_note") }}</label>
        <Toggle
          :toggledText="$t('common.yes')"
          :notToggledText="$t('common.no')"
          :is-active="!!localData.generate_delivery_note"
          :on-change="onGenerateDeliveryNoteChange"
        />
      </div>
    </div>
    <ParcelSelector
      ref="parcelSelector"
      v-if="localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT"
      :visible="showParcelSelectDialog"
      :selectedParcelUuids="localData.selectedParcels.map((parcel) => parcel.uuid)"
      :filterData="{
        unit_legal_entity_uuid: unitLegalEntityUuid,
      }"
      @close="showParcelSelectDialog = false"
      @continue="onContinueFromParcelSelector"
      :multiselect="true"
      :singleParcelDepartment="false"
    />
    <PartnerSelector
      ref="partnerSelector"
      :visible="showPartnerDialog"
      @close="showPartnerDialog = false"
      @continue="onContinueFromPartnerSelector"
      :multiselect="false"
    />
    <ProductSelector
      ref="productSelector"
      :visible="showProductSelectDialog"
      @close="showProductSelectDialog = false"
      @continue="onContinueFromProductSelector"
      :multiselect="false"
      :filterData="{
        mesure_unit_group_id: 2, // 2 = weight
      }"
    />
    <ContractsPurchaseSaleSelector
      ref="contractSelector"
      :key="`contract-${contractSelectorKey}`"
      v-if="[WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.SALES, WEIGHING_TYPES.FIELD_REPORT].includes(localData.weighing_type_id)"
      :visible="showContractSelectDialog"
      :selectedContractUuids="localData.selectedContracts?.map((contract) => contract.uuid) ?? []"
      @close="showContractSelectDialog = false"
      @continue="onContinueFromContractSelector"
      :multiselect="false"
      :filterData="{
        contract_type_id: contractTypeFilter,
        product_measure_unit_group_id: 2, // 2 = weight,
        show_completed_rows: 0,
        sale_type: isFieldReportWithSaleAndIntermediary ? 'intragroup' : isFieldReportWithSale ? null : 'partner',
        unit_legal_entity_uuid: unitLegalEntityUuid,
      }"
    />
    <ContractsPurchaseSaleSelector
      ref="secondaryContractSelector"
      :key="`contract-secondary-${contractSelectorKey}`"
      v-if="isFieldReportWithSaleAndIntermediary"
      :visible="showSecondaryContractSelectDialog"
      :selectedContractUuids="localData.selectedSaleContracts?.map((contract) => contract.uuid) ?? []"
      @close="showSecondaryContractSelectDialog = false"
      @continue="onContinueFromSecondaryContractSelector"
      :multiselect="false"
      :filterData="{
        contract_type_id: contractTypeFilter,
        product_uuid: primaryContractProductUuid,
        product_measure_unit_group_id: 2, // 2 = weight,
        show_completed_rows: 0,
        sale_type: 'partner',
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DxSelectBox } from "devextreme-vue/select-box";
import DxTagBox from "devextreme-vue/tag-box";
import { DxRadioGroup } from "devextreme-vue/radio-group";
import ParcelSelector from "@/components/ParcelSelector.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import ContractsPurchaseSaleSelector from "@/components/ContractsPurchaseSaleSelector.vue";
import DxAutocomplete from "devextreme-vue/autocomplete";
import Toggle from "@/components/Toggle.vue";
import PartnerSelector from "@/components/PartnerSelector.vue";
import { errorMessage } from "@/helpers/common";
import { FIELD_REPORT_MODES, WEIGHING_TYPES } from "@/pages/scale/config/weighingTypes";

export default {
  name: "load",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData }, // Create a local copy of formData
      receptionTypesList: [
        {
          id: 1,
          name: this.$t("scale.weighing_on_scale.provider"),
          disabled: false,
        },
        {
          id: 2,
          name: this.$t("common.surface"),
          disabled: false,
        },
      ], // Example data for reception types
      showParcelSelectDialog: false, // Control visibility of ParcelSelector dialog
      showProductSelectDialog: false, // Control visibility of ProductSelector dialog
      showContractSelectDialog: false, // Control visibility of ContractSelector dialog
      showSecondaryContractSelectDialog: false, // Control visibility of secondary ContractSelector dialog
      unloadingPlaceHistory: [],
      uploadPlaceHistory: [],
      productNameCodeHistory: [],
      buyerSellerNameAddressHistory: [],
      partnerNameAddressHistory: [],
      contractSelectorKey: 0,
      skipWarehouseAutofill: false,
      showPartnerDialog: false,
      WEIGHING_TYPES,
    };
  },
  computed: {
    ...mapGetters({
      // products: "smProducts/smProducts",
      warehouses: "smWarehouses/smWarehouses",
    }),
    isFieldReportWithSaleOrWithSaleAndIntermediary() {
      const isFieldReport = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT;
      return (
        isFieldReport &&
        [FIELD_REPORT_MODES.WITH_SALE, FIELD_REPORT_MODES.WITH_SALE_AND_INTERMEDIARY].includes(parseInt(this.localData.field_report_type))
      );
    },
    isFieldReportWithSale() {
      const isFieldReport = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT;
      return isFieldReport && [FIELD_REPORT_MODES.WITH_SALE].includes(parseInt(this.localData.field_report_type));
    },
    isFieldReportWithSaleAndIntermediary() {
      return (
        parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT &&
        parseInt(this.localData.field_report_type) === FIELD_REPORT_MODES.WITH_SALE_AND_INTERMEDIARY
      );
    },
    isIntermediaryWarehouseRequired() {
      const isFieldReport = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT;
      const isSaleMode = [FIELD_REPORT_MODES.WITH_SALE, FIELD_REPORT_MODES.WITH_SALE_AND_INTERMEDIARY].includes(
        parseInt(this.localData.field_report_type),
      );
      const primaryContract = this.localData.selectedContracts?.[0] ?? null;
      return isFieldReport && isSaleMode && primaryContract?.sale_type === "intragroup";
    },
    // True when this is a FIELD_REPORT weighing that has not yet been completed (no positive netto weight).
    // In this state parcels, product and warehouse are all optional.
    isUnfinishedFieldReport() {
      return (
        this.localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT &&
        !((this.localData.full_weight_kg ?? 0) > 0 && ((this.localData.empty_weight_kg ?? 0) >= 0 && !this.localData.empty_datetime))
      );
    },
    hasPartnerSaleContract() {
      const isFieldReport = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT;
      const isSaleMode = [FIELD_REPORT_MODES.WITH_SALE, FIELD_REPORT_MODES.WITH_SALE_AND_INTERMEDIARY].includes(
        parseInt(this.localData.field_report_type),
      );
      const primaryContract = this.localData.selectedContracts?.[0] ?? null;
      const secondaryContract = this.localData.selectedSaleContracts?.[0] ?? null;
      return (primaryContract?.sale_type === "partner" || secondaryContract?.sale_type === "partner") && isFieldReport && isSaleMode;
    },
    showSalePlacesInputs() {
      return this.hasPartnerSaleContract;
    },
    intermediaryUnitUuid() {
      const primaryContract = this.localData.selectedContracts?.[0] ?? null;
      if (!primaryContract || primaryContract.sale_type !== "intragroup") {
        return null;
      }
      return primaryContract?.intragroup_legal_entity_uuid || null;
    },
    intermediaryWarehouses() {
      if (!this.intermediaryUnitUuid) {
        return [];
      }

      // Filter warehouses based on the intermediary unit UUID
      return this.warehouses.filter((warehouse) => {
        const unitUuid = warehouse?.legal_entity_uuid || null;
        return unitUuid === this.intermediaryUnitUuid;
      });
    },
    isContractInputVisible() {
      return [WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.SALES, WEIGHING_TYPES.FIELD_REPORT].includes(
        parseInt(this.localData.weighing_type_id),
      );
    },
    shouldFilterWarehousesByContractLegalEntity() {
      return this.isContractInputVisible && !!this.unitLegalEntityUuid;
    },
    unitLegalEntityUuid() {
      const contractLegalEntityUuid = this.localData.selectedContracts?.[0]?.legal_entity_uuid || null;
      if (contractLegalEntityUuid) {
        return contractLegalEntityUuid;
      }

      const parcelLegalEntityUuids = Array.from(
        new Set(
          (Array.isArray(this.localData.selectedParcels) ? this.localData.selectedParcels : [])
            .map((parcel) => this.getParcelLegalEntityUuid(parcel))
            .filter((uuid) => !!uuid),
        ),
      );
      if (parcelLegalEntityUuids.length === 1) {
        return parcelLegalEntityUuids[0];
      }

      const selectedRecipientWarehouseUuids = Array.isArray(this.localData.recipient_warehouse_uuids)
        ? this.localData.recipient_warehouse_uuids
        : this.localData.recipient_warehouse_uuid
        ? [this.localData.recipient_warehouse_uuid]
        : [];

      const recipientWarehouseLegalEntityUuids = Array.from(
        new Set(
          selectedRecipientWarehouseUuids
            .map((warehouseUuid) => this.getWarehouseByUuid(warehouseUuid))
            .map((warehouse) => this.getWarehouseLegalEntityUuid(warehouse))
            .filter((uuid) => !!uuid),
        ),
      );
      if (recipientWarehouseLegalEntityUuids.length === 1) {
        return recipientWarehouseLegalEntityUuids[0];
      }

      const issuerWarehouse = this.getWarehouseByUuid(this.localData.issuer_warehouse_uuid);
      return this.getWarehouseLegalEntityUuid(issuerWarehouse);
    },
    recipientWarehouses() {
      // Apply contract legal-entity warehouse filtering only when contract input is visible and a contract is selected.
      if (!this.shouldFilterWarehousesByContractLegalEntity || this.isSimpleFieldReportWithoutContract) {
        return this.warehouses;
      }

      return this.warehouses.filter((warehouse) => warehouse?.legal_entity_uuid === this.unitLegalEntityUuid);
    },
    issuerWarehouses() {
      // Apply contract legal-entity warehouse filtering only when contract input is visible and a contract is selected.
      if (!this.shouldFilterWarehousesByContractLegalEntity) {
        return this.warehouses;
      }

      return this.warehouses.filter((warehouse) => warehouse?.legal_entity_uuid === this.unitLegalEntityUuid);
    },
    isFieldReportWeighingForTransport() {
      return (
        parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT &&
        ([FIELD_REPORT_MODES.WEIGHING_FOR_TRANSPORT].includes(parseInt(this.localData.field_report_type)) ||
          !this.localData.field_report_type)
      );
    },
    isFieldReportSimple() {
      return (
        parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.FIELD_REPORT &&
        ([FIELD_REPORT_MODES.SIMPLE, FIELD_REPORT_MODES.WEIGHING_FOR_TRANSPORT].includes(parseInt(this.localData.field_report_type)) ||
          !this.localData.field_report_type)
      );
    },
    isSimpleFieldReportWithoutContract() {
      return (
        this.isFieldReportSimple && (!Array.isArray(this.localData.selectedContracts) || this.localData.selectedContracts.length === 0)
      );
    },
    primaryContractProductUuid() {
      return this.localData.selectedContracts?.[0]?.product_uuid || null;
    },
    contractTypeFilter() {
      if (parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.RECEPTION) {
        return "1";
      }

      if (this.isFieldReportWithSaleOrWithSaleAndIntermediary) {
        return "2";
      }

      return "2, 3";
    },
    getSelectedParcelSurfaceDecimal() {
      return this.localData.selectedParcels && this.localData.selectedParcels.length > 0
        ? this.localData.selectedParcels
            .map((l) => l.surface)
            .reduce((x, y) => {
              return (parseFloat(x) + parseFloat(y)).toFixed(2);
            })
        : 0;
    },
    getParcelNames() {
      return this.localData.selectedParcels.map((l) => l.name).join(", ");
    },
    getSelectedParcelCountForInput() {
      return (
        "" +
        this.localData.selectedParcels.length +
        (this.localData.selectedParcels.length == 1 ? " parcelă selectată" : " parcele selectate") +
        " (" +
        this.getSelectedParcelSurfaceDecimal +
        " ha)"
      );
    },
    getContractNames() {
      if (!this.localData.selectedContracts || this.localData.selectedContracts.length === 0) {
        return " - ";
      }
      return this.localData.selectedContracts?.map((l) => l.contract_number).join(", ");
    },
    getSecondaryContractNames() {
      if (!this.localData.selectedSaleContracts || this.localData.selectedSaleContracts.length === 0) {
        return " - ";
      }
      return this.localData.selectedSaleContracts?.map((l) => l.contract_number).join(", ");
    },
    getPartnerNames() {
      if (!this.localData.partner_name) {
        return " - ";
      }
      return this.localData.partner_name;
    },
    getProductNames() {
      if (!this.localData.product_name) {
        return " - ";
      }
      return this.localData.product_name;
    },
  },
  components: {
    DxSelectBox,
    DxTagBox,
    DxRadioGroup,
    ParcelSelector,
    DxAutocomplete,
    Toggle,
    ProductSelector,
    ContractsPurchaseSaleSelector,
    PartnerSelector,
  },
  methods: {
    ...mapActions({
      getWeighingOnScaleAutocompleteData: "scale/getWeighingOnScaleAutocompleteData",
    }),
    onReceptionTypeChanged(event) {
      // this.localData.reception_type_id = event.value; // Update local data with selected value
      /*if (event.value == 1) {
        this.localData.selectedParcels = []; // Reset selected parcels if reception type is Provider
      } else if (event.value == 2) {
        this.localData.partner_uuid = null; // Reset partner UUID if reception type is Surface
        this.localData.partner_name = "";
      }*/
    },
    parcelClick() {
      this.showParcelSelectDialog = true; // Show the ParcelSelector dialog
    },
    contractClick() {
      this.showContractSelectDialog = true; // Show the ContractSelector dialog
    },
    secondaryContractClick() {
      this.showSecondaryContractSelectDialog = true; // Show the secondary ContractSelector dialog
    },
    productClick() {
      const selectedContract = this.localData.selectedContracts.length > 0 ? this.localData.selectedContracts[0] : null;
      if (selectedContract) {
        errorMessage(this, this.$t("scale.weighing_on_scale.error_product_not_changable_if_contract_selected"));
        return;
      }
      this.showProductSelectDialog = true; // Show the ProductSelector dialog
    },
    /*onProductChanged(event) {
      // this.localData.product_name = event.component.option("displayValue"); // Update local data with selected value
      const selectedProduct = this.products.find((product) => product.uuid === event.value);
      if (selectedProduct) {
        this.localData.product_name = selectedProduct.name;
        this.localData.product_code = selectedProduct.code;
      }
    },*/
    partnerClick() {
      if (this.localData.selectedContracts?.length > 0) {
        return;
      }
      this.showPartnerDialog = true;
    },
    onContinueFromPartnerSelector(selectedPartners) {
      const selectedPartner = selectedPartners && selectedPartners.length > 0 ? selectedPartners[0] : null;
      this.localData.partner_uuid = selectedPartner?.uuid ?? null;
      this.localData.partner_name = selectedPartner?.name ?? null;

      if (selectedPartner) {
        this.localData.partner_address = selectedPartner?.locality?.DENUMIRE ?? "";
        if (this.localData.partner_address && selectedPartner?.street_and_number) {
          this.localData.partner_address += ", ";
        }
        this.localData.partner_address += selectedPartner?.street_and_number ?? "";
      } else {
        this.localData.partner_address = null;
      }

      // Reset warehouse when partner changes
      if (parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.RECEPTION) {
        this.localData.recipient_warehouse_uuid = null;
        this.localData.recipient_warehouse_uuids = [];
        this.localData.recipient_warehouse_name = "";
      } else if (parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.SALES) {
        this.localData.issuer_warehouse_uuid = null;
        this.localData.issuer_warehouse_name = "";
      }

      this.showPartnerDialog = false;
    },
    onWarehouseChangedRecipient(event) {
      this.handleWarehouseChange(event);
    },
    onGenerateDeliveryNoteChange(value) {
      this.$set(this.localData, "generate_delivery_note", !!value);
    },
    onRecipientWarehousesChanged(event) {
      const selectedUuids = Array.isArray(event?.value) ? event.value : [];
      this.localData.recipient_warehouse_uuids = selectedUuids;

      if (selectedUuids.length > 0) {
        const selectedWarehouse = this.warehouses.find((warehouse) => warehouse.uuid === selectedUuids[0]);
        this.localData.recipient_warehouse_uuid = selectedWarehouse?.uuid || null;
        this.localData.recipient_warehouse_name = selectedWarehouse?.name || "";
        this.localData.buyer_seller_uuid = selectedWarehouse?.department?.uuid || null;
        this.localData.buyer_seller_name = selectedWarehouse?.legal_entity_name || selectedWarehouse?.department?.name || "";
        this.localData.buyer_seller_address = selectedWarehouse?.legal_entity_address || "";
      } else {
        this.localData.recipient_warehouse_uuid = null;
        this.localData.recipient_warehouse_name = "";
      }

      this.enforceLegalEntityConsistency("recipientWarehouse");
    },
    onWarehouseChangedIssuer(event) {
      this.handleWarehouseChange(event, true);
    },
    onIntermediaryWarehouseChanged(event) {
      const selectedWarehouse = this.warehouses.find((warehouse) => warehouse.uuid === event.value);
      if (selectedWarehouse) {
        this.localData.intermediary_warehouse_name = selectedWarehouse.name;
      } else {
        this.localData.intermediary_warehouse_name = "";
      }
    },
    getWarehouseByUuid(warehouseUuid) {
      if (!warehouseUuid) {
        return null;
      }
      return this.warehouses.find((warehouse) => warehouse.uuid === warehouseUuid) || null;
    },
    getWarehouseLegalEntityUuid(warehouse) {
      return warehouse?.legal_entity_uuid ?? warehouse?.department?.uuid ?? null;
    },
    getParcelLegalEntityUuid(parcel) {
      return parcel?.legal_entity?.uuid ?? parcel?.department_uuid ?? null;
    },
    clearWarehouseSelection(issuer = false) {
      if (issuer) {
        this.localData.issuer_warehouse_uuid = null;
        this.localData.issuer_warehouse_name = "";
      } else {
        this.localData.recipient_warehouse_uuid = null;
        this.localData.recipient_warehouse_uuids = [];
        this.localData.recipient_warehouse_name = "";
      }

      if (!this.localData.recipient_warehouse_uuid && !this.localData.issuer_warehouse_uuid) {
        this.localData.buyer_seller_uuid = null;
        this.localData.buyer_seller_name = "";
        this.localData.buyer_seller_address = "";
      }
    },
    getLegalEntityConsistencyIssue() {
      if (this.isSimpleFieldReportWithoutContract) {
        const selectedRecipientWarehouseUuids = Array.isArray(this.localData.recipient_warehouse_uuids)
          ? this.localData.recipient_warehouse_uuids
          : this.localData.recipient_warehouse_uuid
          ? [this.localData.recipient_warehouse_uuid]
          : [];

        const selectedRecipientWarehouses = selectedRecipientWarehouseUuids
          .map((uuid) => this.getWarehouseByUuid(uuid))
          .filter((warehouse) => !!warehouse);

        const parcelLegalEntityUuids = new Set(
          (Array.isArray(this.localData.selectedParcels) ? this.localData.selectedParcels : [])
            .map((parcel) => this.getParcelLegalEntityUuid(parcel))
            .filter((uuid) => !!uuid),
        );

        const warehouseLegalEntityUuids = new Set(
          selectedRecipientWarehouses.map((warehouse) => this.getWarehouseLegalEntityUuid(warehouse)).filter((uuid) => !!uuid),
        );

        if (parcelLegalEntityUuids.size > 0 && warehouseLegalEntityUuids.size > 0) {
          const everyParcelHasWarehouse = Array.from(parcelLegalEntityUuids).every((uuid) => warehouseLegalEntityUuids.has(uuid));
          const everyWarehouseHasParcel = Array.from(warehouseLegalEntityUuids).every((uuid) => parcelLegalEntityUuids.has(uuid));

          if (!everyParcelHasWarehouse || !everyWarehouseHasParcel) {
            return {
              type: "parcel_warehouse_set_mismatch",
              messageKey: "works.parcels.parcel_warehouse_legal_entity_coverage_error",
            };
          }
        }

        return null;
      }

      const contractLegalEntityUuid = this.localData.selectedContracts?.[0]?.legal_entity_uuid || null;

      const recipientWarehouse = this.getWarehouseByUuid(this.localData.recipient_warehouse_uuid);
      const recipientWarehouseLegalEntityUuid = this.getWarehouseLegalEntityUuid(recipientWarehouse);

      const issuerWarehouse = this.getWarehouseByUuid(this.localData.issuer_warehouse_uuid);
      const issuerWarehouseLegalEntityUuid = this.getWarehouseLegalEntityUuid(issuerWarehouse);

      if (contractLegalEntityUuid && recipientWarehouseLegalEntityUuid && recipientWarehouseLegalEntityUuid !== contractLegalEntityUuid) {
        return {
          type: "contract_warehouse",
          warehouse: "recipient",
          messageKey: "scale.weighing_on_scale.error_warehouse_legal_entity_mismatch",
        };
      }

      if (contractLegalEntityUuid && issuerWarehouseLegalEntityUuid && issuerWarehouseLegalEntityUuid !== contractLegalEntityUuid) {
        return {
          type: "contract_warehouse",
          warehouse: "issuer",
          messageKey: "scale.weighing_on_scale.error_warehouse_legal_entity_mismatch",
        };
      }

      const targetLegalEntityUuid = contractLegalEntityUuid || recipientWarehouseLegalEntityUuid || issuerWarehouseLegalEntityUuid || null;

      if (targetLegalEntityUuid && Array.isArray(this.localData.selectedParcels) && this.localData.selectedParcels.length > 0) {
        const allParcelsMatch = this.localData.selectedParcels.every(
          (parcel) => this.getParcelLegalEntityUuid(parcel) === targetLegalEntityUuid,
        );

        if (!allParcelsMatch && contractLegalEntityUuid) {
          return {
            type: "parcel_legal_entity",
            messageKey: "works.parcels.parcel_contract_department_error",
          };
        }

        if (!allParcelsMatch) {
          return {
            type: "parcel_legal_entity",
            messageKey: "works.parcels.parcel_warehouse_department_error",
          };
        }
      }

      return null;
    },
    enforceLegalEntityConsistency(changedSource = null) {
      if (this.isSimpleFieldReportWithoutContract) {
        const issue = this.getLegalEntityConsistencyIssue();
        if (issue && changedSource === "contract") {
          errorMessage(this, this.$t(issue.messageKey));
          return false;
        }
        return true;
      }

      let iteration = 0;
      let issue = this.getLegalEntityConsistencyIssue();
      let messageKey = null;

      while (issue && iteration < 5) {
        if (!messageKey) {
          messageKey = issue.messageKey;
        }

        if (issue.type === "contract_warehouse") {
          this.clearWarehouseSelection(issue.warehouse === "issuer");
        } else if (issue.type === "parcel_legal_entity") {
          if (changedSource === "recipientWarehouse" && this.localData.recipient_warehouse_uuid) {
            this.clearWarehouseSelection(false);
          } else if (changedSource === "issuerWarehouse" && this.localData.issuer_warehouse_uuid) {
            this.clearWarehouseSelection(true);
          } else {
            this.localData.selectedParcels = [];
          }
        }

        issue = this.getLegalEntityConsistencyIssue();
        iteration += 1;
      }

      if (messageKey) {
        errorMessage(this, this.$t(messageKey));
        return false;
      }

      return true;
    },
    handleWarehouseChange(event, issuer = false) {
      const selectedWarehouse = this.warehouses.find((warehouse) => warehouse.uuid === event.value);
      const isTransferMode = parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.TRANSFER;

      if (selectedWarehouse) {
        if (issuer) {
          this.localData.issuer_warehouse_name = selectedWarehouse.name;
        } else {
          this.localData.recipient_warehouse_name = selectedWarehouse.name;
        }

        // For TRANSFER type: populate buyer_seller from issuer, partner from recipient
        if (isTransferMode) {
          if (issuer) {
            this.localData.buyer_seller_uuid = selectedWarehouse.department.uuid;
            this.localData.buyer_seller_name = selectedWarehouse.legal_entity_name || selectedWarehouse.department?.name;
            this.localData.buyer_seller_address = selectedWarehouse.legal_entity_address;
          } else {
            this.localData.partner_name = selectedWarehouse.legal_entity_name || selectedWarehouse.department?.name;
            this.localData.partner_address = selectedWarehouse.legal_entity_address;
          }
        } else {
          this.localData.buyer_seller_uuid = selectedWarehouse.department.uuid;
          this.localData.buyer_seller_name = selectedWarehouse.legal_entity_name || selectedWarehouse.department?.name;
          this.localData.buyer_seller_address = selectedWarehouse.legal_entity_address;
        }

        this.enforceLegalEntityConsistency(issuer ? "issuerWarehouse" : "recipientWarehouse");
      } else if (!issuer) {
        this.localData.recipient_warehouse_name = "";
        this.localData.recipient_warehouse_uuid = null;
        this.localData.recipient_warehouse_uuids = [];
      }
    },
    onContinueFromParcelSelector(selectedParcels) {
      this.localData.selectedParcels = selectedParcels; // Update localData with selected parcels
      this.enforceLegalEntityConsistency("parcels");
      this.showParcelSelectDialog = false; // Close the ParcelSelector dialog
    },
    onContinueFromContractSelector(selectedContracts) {
      if (this.isFieldReportWithSaleAndIntermediary) {
        const candidate = selectedContracts[0];
        if (candidate && candidate.sale_type !== "intragroup") {
          errorMessage(this, this.$t("scale.weighing_on_scale.error_primary_contract_must_intragroup"));
          this.showContractSelectDialog = false;
          return;
        }
      }

      if (
        this.isFieldReportWithSaleOrWithSaleAndIntermediary &&
        selectedContracts.length > 0 &&
        parseInt(selectedContracts[0].contract_type_id) === 3
      ) {
        errorMessage(this, this.$t("scale.weighing_on_scale.error_contract_type_not_allowed"));
        this.showContractSelectDialog = false;
        return;
      }

      this.localData.selectedContracts = selectedContracts; // Update localData with selected contracts
      if (selectedContracts.length > 0) {
        this.localData.recipient_warehouse_uuids = [];
        this.localData.product_uuid = selectedContracts[0].product_uuid;
        this.localData.partner_uuid = selectedContracts[0].partner_uuid;
        this.localData.product_name = selectedContracts[0].product_name;
        this.localData.partner_name = selectedContracts[0].partner_name;

        this.localData.contract_number = selectedContracts[0].contract_number;

        // Set custody based on contract_type_id
        if (selectedContracts[0].contract_type_id == 3) {
          this.localData.custody = true;
        } else {
          this.localData.custody = false;
        }
      }

      if (this.isFieldReportWithSaleAndIntermediary && this.localData.selectedSaleContracts?.length > 0) {
        const primaryContract = this.localData.selectedContracts?.[0] ?? null;
        const secondaryContract = this.localData.selectedSaleContracts?.[0] ?? null;
        const primaryUnitLegalEntityUuid = primaryContract?.intragroup_legal_entity_uuid || null;
        const secondaryLegalEntityUuid = secondaryContract?.legal_entity_uuid /*|| secondaryContract?.legal_entity?.uuid*/ || null;

        if (
          !primaryContract ||
          !secondaryContract ||
          primaryContract.sale_type !== "intragroup" ||
          secondaryContract.sale_type !== "partner" ||
          (primaryContract.product_uuid &&
            secondaryContract.product_uuid &&
            primaryContract.product_uuid !== secondaryContract.product_uuid) ||
          (primaryUnitLegalEntityUuid && secondaryLegalEntityUuid && primaryUnitLegalEntityUuid !== secondaryLegalEntityUuid)
        ) {
          this.localData.selectedSaleContracts = [];
          this.localData.intermediary_warehouse_uuid = null;
          this.localData.intermediary_warehouse_name = "";
        }
      }

      this.enforceLegalEntityConsistency("contract");

      // Refresh product & warehouse data based on contract's legal_entity_uuid
      this.localData.issuer_warehouse_uuid = null;
      this.localData.issuer_warehouse_name = "";
      
      if (this.$refs.productSelector && this.$refs.productSelector.instance) {
        this.$refs.productSelector.instance.refresh();
      }

      this.showContractSelectDialog = false; // Close the ContractSelector dialog
    },
    onContinueFromSecondaryContractSelector(selectedContracts) {
      if (!this.isFieldReportWithSaleAndIntermediary) {
        this.showSecondaryContractSelectDialog = false;
        return;
      }

      const candidate = selectedContracts[0];
      if (candidate && candidate.sale_type !== "partner") {
        errorMessage(this, this.$t("scale.weighing_on_scale.error_secondary_contract_must_partner"));
        this.showSecondaryContractSelectDialog = false;
        return;
      }

      const primaryContract = this.localData.selectedContracts?.[0] ?? null;
      if (primaryContract && candidate) {
        if (primaryContract.product_uuid && candidate.product_uuid && primaryContract.product_uuid !== candidate.product_uuid) {
          errorMessage(this, this.$t("scale.weighing_on_scale.error_contract_product_mismatch"));
          this.showSecondaryContractSelectDialog = false;
          return;
        }

        const primaryUnitLegalEntityUuid = primaryContract.intragroup_legal_entity_uuid || null;
        const secondaryLegalEntityUuid = candidate.legal_entity_uuid || candidate.legal_entity?.uuid || null;

        if (primaryUnitLegalEntityUuid && secondaryLegalEntityUuid && primaryUnitLegalEntityUuid !== secondaryLegalEntityUuid) {
          errorMessage(this, this.$t("scale.weighing_on_scale.error_contract_legal_entity_mismatch"));
          this.showSecondaryContractSelectDialog = false;
          return;
        }
      }

      this.localData.selectedSaleContracts = selectedContracts;
      this.localData.intermediary_warehouse_uuid = null;
      this.localData.intermediary_warehouse_name = "";
      this.showSecondaryContractSelectDialog = false;
    },
    clearSelectedContracts() {
      this.localData.selectedContracts = [];
      this.localData.contract_number = "";
      this.localData.selectedParcels = [];
      this.localData.recipient_warehouse_uuid = null;
      this.localData.recipient_warehouse_uuids = [];
      this.localData.recipient_warehouse_name = "";
      this.localData.issuer_warehouse_uuid = null;
      this.localData.issuer_warehouse_name = "";
    },
    clearSelectedParcels() {
      this.localData.selectedParcels = [];
      this.enforceLegalEntityConsistency("parcels");
    },
    clearSelectedSecondaryContracts() {
      this.localData.selectedSaleContracts = [];
      this.localData.intermediary_warehouse_uuid = null;
      this.localData.intermediary_warehouse_name = "";
    },
    onContinueFromProductSelector(selectedProducts) {
      // just one product can be selected now, in the future possible multi
      selectedProducts.forEach((product) => {
        this.localData.product_uuid = product.uuid;
        this.localData.product_name = product.name;
        this.localData.product_code = product.code;
      });

      this.showProductSelectDialog = false; // Close the dialog after selection
    },
    warehouseDisplayExpr(warehouse) {
      return warehouse ? `${warehouse.name} (${warehouse.legal_entity_name || warehouse.department?.name})` : "";
    },
    validate() {
      this.$v.$touch(); // Trigger validation
      if (this.$v.$invalid) {
        return {
          error: true,
          message: "",
        };
      }

      if (this.isFieldReportWithSaleAndIntermediary) {
        const primaryContract = this.localData.selectedContracts?.[0] ?? null;
        const secondaryContract = this.localData.selectedSaleContracts?.[0] ?? null;

        if (!primaryContract || !secondaryContract) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_secondary_contract_required"),
          };
        }

        if (primaryContract.sale_type !== "intragroup" || secondaryContract.sale_type !== "partner") {
          return {
            error: true,
            message:
              primaryContract.sale_type !== "intragroup"
                ? this.$t("scale.weighing_on_scale.error_primary_contract_must_intragroup")
                : this.$t("scale.weighing_on_scale.error_secondary_contract_must_partner"),
          };
        }

        if (
          primaryContract.product_uuid &&
          secondaryContract.product_uuid &&
          primaryContract.product_uuid !== secondaryContract.product_uuid
        ) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_contract_product_mismatch"),
          };
        }

        const primaryUnitLegalEntityUuid = primaryContract.intragroup_legal_entity_uuid || null;
        const secondaryLegalEntityUuid = secondaryContract.legal_entity_uuid /*|| secondaryContract.legal_entity?.uuid*/ || null;

        if (primaryUnitLegalEntityUuid && secondaryLegalEntityUuid && primaryUnitLegalEntityUuid !== secondaryLegalEntityUuid) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_contract_legal_entity_mismatch"),
          };
        }

        // fall through to intermediary warehouse validation below
      }

      if (this.isFieldReportWithSaleOrWithSaleAndIntermediary) {
        if (!Array.isArray(this.localData.selectedContracts) || this.localData.selectedContracts.length === 0) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_contract_required"),
          };
        }

        if (parseInt(this.localData.selectedContracts[0]?.contract_type_id) === 3) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_contract_type_not_allowed"),
          };
        }
      }

      if (this.isIntermediaryWarehouseRequired) {
        const primaryContract = this.localData.selectedContracts?.[0] ?? null;
        const primaryUnitUuid = primaryContract?.intragroup_legal_entity_uuid || null;

        const selectedIntermediaryWarehouse = this.warehouses.find((w) => w.uuid === this.localData.intermediary_warehouse_uuid);
        if (!selectedIntermediaryWarehouse) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_intermediary_warehouse_required"),
          };
        }

        const intermediaryUnitUuid = selectedIntermediaryWarehouse?.legal_entity_uuid || null;
        if (intermediaryUnitUuid && primaryUnitUuid && intermediaryUnitUuid !== primaryUnitUuid) {
          return {
            error: true,
            message: this.$t("scale.weighing_on_scale.error_intermediary_warehouse_unit_mismatch"),
          };
        }
      }

      if (!!this.localData.field_report && this.localData.custody && this.localData.partner_uuid == null) {
        return {
          error: true,
          message: this.$t("works.parcels.select_partner_for_custody"),
        };
      }

      if (parseInt(this.localData.weighing_type_id) === WEIGHING_TYPES.TRANSFER) {
        if (!this.localData.issuer_warehouse_uuid || !this.localData.recipient_warehouse_uuid) {
          return {
            error: true,
            message: this.$t("fill_out_error"),
          };
        }
      }

      const legalEntityIssue = this.getLegalEntityConsistencyIssue();
      if (legalEntityIssue) {
        return {
          error: true,
          message: this.$t(legalEntityIssue.messageKey),
        };
      }

      return {
        error: false,
        message: "",
      };
    },
    updateData(newData) {
      const previousWeighingTypeId = parseInt(this.localData.weighing_type_id);
      const incomingWeighingTypeId = parseInt(newData.weighing_type_id);
      const hasWeighingTypeChanged = previousWeighingTypeId !== incomingWeighingTypeId;

      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        this.localData = { ...newData }; // Update localData with new data

        if (hasWeighingTypeChanged) {
          this.skipWarehouseAutofill = true;
          this.clearSelectedContracts();
          this.clearSelectedSecondaryContracts();
          this.clearSelectedParcels();
          this.contractSelectorKey += 1;

          this.$nextTick(() => {
            this.skipWarehouseAutofill = false;
          });
        }

        if (!Array.isArray(this.localData.recipient_warehouse_uuids)) {
          this.localData.recipient_warehouse_uuids = this.localData.recipient_warehouse_uuid
            ? [this.localData.recipient_warehouse_uuid]
            : [];
        }

        if (!Array.isArray(this.localData.selectedSaleContracts)) {
          this.localData.selectedSaleContracts = [];
        }

        if (!this.localData.intermediary_warehouse_uuid) {
          this.localData.intermediary_warehouse_name = "";
        }

        if (!this.isFieldReportWithSaleAndIntermediary && this.localData.selectedSaleContracts.length > 0) {
          this.localData.selectedSaleContracts = [];
          this.localData.intermediary_warehouse_uuid = null;
          this.localData.intermediary_warehouse_name = "";
        }
      }
    },
    getProductNameHistory() {
      // Returns a list of product names from productNameCodeHistory
      if (!Array.isArray(this.productNameCodeHistory)) return [];
      return this.productNameCodeHistory.filter((item) => item.name).map((item) => item.name);
    },
    getProductCodeHistory() {
      // Returns a list of product codes from productNameCodeHistory
      if (!Array.isArray(this.productNameCodeHistory)) return [];
      return this.productNameCodeHistory.filter((item) => item.code).map((item) => item.code);
    },
    getBuyerSellerNameHistory() {
      // Returns a list of buyer/seller names from buyerSellerNameAddressHistory
      if (!Array.isArray(this.buyerSellerNameAddressHistory)) return [];
      return this.buyerSellerNameAddressHistory.filter((item) => item.name).map((item) => item.name);
    },
    getBuyerSellerAddressHistory() {
      // Returns a list of buyer/seller addresses from buyerSellerNameAddressHistory
      if (!Array.isArray(this.buyerSellerNameAddressHistory)) return [];
      return this.buyerSellerNameAddressHistory.filter((item) => item.address).map((item) => item.address);
    },
    getPartnerNameHistory() {
      // Returns a list of partner names from partnerNameAddressHistory
      if (!Array.isArray(this.partnerNameAddressHistory)) return [];
      return this.partnerNameAddressHistory.filter((item) => item.name).map((item) => item.name);
    },
    getPartnerAddressHistory() {
      // Returns a list of partner addresses from partnerNameAddressHistory
      if (!Array.isArray(this.partnerNameAddressHistory)) return [];
      return this.partnerNameAddressHistory.filter((item) => item.address).map((item) => item.address);
    },
    onProductNameSelected(e) {
      const productName = e.value;
      if (!productName) return null;
      const relation = this.productNameCodeHistory.find((r) => r.name === productName);
      if (relation) {
        this.localData.product_code = relation.code || "";
      }
    },
    onBuyerSellerNameSelected(e) {
      const buyerSellerName = e.value;
      if (!buyerSellerName) return null;
      const relation = this.buyerSellerNameAddressHistory.find((r) => r.name === buyerSellerName);
      if (relation) {
        this.localData.buyer_seller_address = relation.address || "";
      }
    },
    onPartnerNameSelected(e) {
      const partnerName = e.value;
      if (!partnerName) return null;
      const relation = this.partnerNameAddressHistory.find((r) => r.name === partnerName);
      if (relation) {
        this.localData.partner_address = relation.address || "";
      }
    },
    loadHistoryData() {
      var history_types = ["unloading_places", "uploading_places"];
      if (this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS) {
        history_types.push("product_name_code");
        history_types.push("buyer_seller_name_address");
        history_types.push("partner_name_address");
      }

      if (this.localData.field_report) {
        history_types.push("contract_numbers");
      }

      this.getWeighingOnScaleAutocompleteData({
        history_types: history_types,
      }).then((response) => {
        if (response && response.data) {
          this.unloadingPlaceHistory = response.data.unloading_places || [];
          this.uploadPlaceHistory = response.data.uploading_places || [];

          if (this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS) {
            this.productNameCodeHistory = response.data.product_name_code || "";
            this.buyerSellerNameAddressHistory = response.data.buyer_seller_name_address || "";
            this.partnerNameAddressHistory = response.data.partner_name_address || "";
          }
        }
      });
    },
    getFilteredWarehousesByLegalEntity() {
      const contractLegalEntityUuid = this.localData.selectedContracts?.[0]?.legal_entity_uuid || null;
      if (!contractLegalEntityUuid) {
        return this.warehouses;
      }
      return this.warehouses.filter((warehouse) => warehouse?.legal_entity_uuid === contractLegalEntityUuid);
    },
  },
  mounted() {
    this.loadHistoryData();
  },
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-form-data", newData, 3); // Emit updated data to parent
      },
    },
    formData: {
      deep: true,
      handler(newData) {
        if (parseInt(this.localData.weighing_type_id) != newData.weighing_type_id) {
          this.skipWarehouseAutofill = true;
          this.clearSelectedContracts();
          this.clearSelectedSecondaryContracts();
          this.clearSelectedParcels();
          this.localData.weighing_type_id = newData.weighing_type_id;
          this.contractSelectorKey += 1;

          this.localData.recipient_warehouse_uuid = null;
          this.localData.recipient_warehouse_uuids = [];
          this.localData.recipient_warehouse_name = "";
          this.localData.issuer_warehouse_uuid = null;
          this.localData.issuer_warehouse_name = "";

          if (newData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS) {
            this.loadHistoryData();
          }
          if (parseInt(this.localData.weighing_type_id) == WEIGHING_TYPES.FIELD_REPORT) {
            this.localData.partner_uuid = null; // Reset partner UUID if reception type is Surface
            this.localData.partner_name = "";
          }

          this.$nextTick(() => {
            this.skipWarehouseAutofill = false;
          });
        }
      },
    },
    recipientWarehouses(newWarehouses) {
      const isRecipientVisible = [WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.FIELD_REPORT, WEIGHING_TYPES.TRANSFER].includes(
        parseInt(this.localData.weighing_type_id),
      );

      if (
        !this.skipWarehouseAutofill &&
        isRecipientVisible &&
        Array.isArray(newWarehouses) &&
        newWarehouses.length === 1 &&
        !this.localData.recipient_warehouse_uuid
      ) {
        this.$nextTick(() => {
          const warehouse = newWarehouses[0];
          this.localData.recipient_warehouse_uuid = warehouse.uuid;
          this.localData.recipient_warehouse_name = warehouse.name;
          this.onRecipientWarehousesChanged({ value: [warehouse.uuid] });
        });
      }
    },
    issuerWarehouses(newWarehouses) {
      const isIssuerVisible = [WEIGHING_TYPES.SALES, WEIGHING_TYPES.TRANSFER].includes(parseInt(this.localData.weighing_type_id));

      if (
        !this.skipWarehouseAutofill &&
        isIssuerVisible &&
        Array.isArray(newWarehouses) &&
        newWarehouses.length === 1 &&
        !this.localData.issuer_warehouse_uuid
      ) {
        this.$nextTick(() => {
          const warehouse = newWarehouses[0];
          this.localData.issuer_warehouse_uuid = warehouse.uuid;
          this.localData.issuer_warehouse_name = warehouse.name;
          this.onWarehouseChangedIssuer({ value: warehouse.uuid });
        });
      }
    },
    intermediaryWarehouses(newWarehouses) {
      if (
        !this.skipWarehouseAutofill &&
        this.isIntermediaryWarehouseRequired &&
        Array.isArray(newWarehouses) &&
        newWarehouses.length === 1 &&
        !this.localData.intermediary_warehouse_uuid
      ) {
        this.$nextTick(() => {
          const warehouse = newWarehouses[0];
          this.localData.intermediary_warehouse_uuid = warehouse.uuid;
          this.localData.intermediary_warehouse_name = warehouse.name;
          this.onIntermediaryWarehouseChanged({ value: warehouse.uuid });
        });
      }
    },
    'localData.weighing_type_id': function(newVal) {
      // When contract input hides, reset warehouses to show full list
      const isContractVisible = [WEIGHING_TYPES.RECEPTION, WEIGHING_TYPES.SALES, WEIGHING_TYPES.FIELD_REPORT].includes(parseInt(newVal));
      if (!isContractVisible) {
        this.localData.recipient_warehouse_uuid = null;
        this.localData.recipient_warehouse_uuids = [];
        this.localData.recipient_warehouse_name = "";
        this.localData.issuer_warehouse_uuid = null;
        this.localData.issuer_warehouse_name = "";
      }
    },
  },
  validations() {
    return {
      localData: {
        product_uuid: {
          required: (value) =>
            this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS || this.isUnfinishedFieldReport || !!value,
        },
        partner_uuid: {
          required: (value) =>
            this.localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT ||
            this.localData.weighing_type_id == WEIGHING_TYPES.TRANSFER ||
            this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS ||
            !!value,
        },
        recipient_warehouse_uuid: {
          required: (value) =>
            this.localData.weighing_type_id == WEIGHING_TYPES.SALES ||
            this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS ||
            this.isUnfinishedFieldReport ||
            this.isFieldReportWeighingForTransport ||
            (this.isSimpleFieldReportWithoutContract
              ? Array.isArray(this.localData.recipient_warehouse_uuids) && this.localData.recipient_warehouse_uuids.length > 0
              : !!value),
        },
        issuer_warehouse_uuid: {
          required: (value) =>
            this.localData.weighing_type_id == WEIGHING_TYPES.RECEPTION ||
            this.localData.weighing_type_id == WEIGHING_TYPES.FIELD_REPORT ||
            this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS ||
            !!value,
        },
        product_name: {
          required: (value) => this.localData.weighing_type_id != WEIGHING_TYPES.CONTRACTED_MEASUREMENTS || !!value,
        },
        partner_name: {
          required: (value) => this.localData.weighing_type_id != WEIGHING_TYPES.CONTRACTED_MEASUREMENTS || !!value,
        },
        buyer_seller_name: {
          required: (value) => this.localData.weighing_type_id != WEIGHING_TYPES.CONTRACTED_MEASUREMENTS || !!value,
        },
        selectedParcels: {
          required: (value) =>
            this.localData.weighing_type_id != WEIGHING_TYPES.FIELD_REPORT ||
            this.localData.weighing_type_id == WEIGHING_TYPES.CONTRACTED_MEASUREMENTS ||
            this.isUnfinishedFieldReport ||
            value.length > 0,
        },
        selectedContracts: {
          required: (value) => !this.isFieldReportWithSaleOrWithSaleAndIntermediary || (Array.isArray(value) && value.length > 0),
        },
        selectedSaleContracts: {
          required: (value) => !this.isFieldReportWithSaleAndIntermediary || (Array.isArray(value) && value.length > 0),
        },
        intermediary_warehouse_uuid: {
          required: (value) => !this.isIntermediaryWarehouseRequired || !!value,
        },
      },
    };
  },
};
</script>

<style scoped>
@import "@/assets/scss/components/selectButtonStyle.scss";

.wos-load {
  height: 100%;
  width: 100%;
}

.field_report {
  border-top: 1px dashed #d1d1d1;
  padding-bottom: 20px;
}

.reception_input_second_value {
  font-size: 12px;
  color: #000000;
}
</style>
